module.exports = __webpack_public_path__ + "static/bibinkan-kakanin-fba186f23c8d3ccdb635bb75c9b1c81b.jpg";